import { render, staticRenderFns } from "./WidgetRow.vue?vue&type=template&id=4d5b4544&scoped=true"
import script from "./WidgetRow.vue?vue&type=script&lang=js"
export * from "./WidgetRow.vue?vue&type=script&lang=js"
import style0 from "./WidgetRow.vue?vue&type=style&index=0&id=4d5b4544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b4544",
  null
  
)

export default component.exports